import { isSupportedBrowser } from '@/utils/supportedBrowsers';
import * as Sentry from '@sentry/nextjs';

// Common Sentry configuration
export const SENTRY_DSN = 'https://6a9b247e1782272dcf8603b2717b418a@o1366951.ingest.us.sentry.io/4506542484881408';

export const getCommonSentryConfig = () => ({
  dsn: SENTRY_DSN,
  enabled: process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_SENTRY_ENV === 'production',
  tracesSampleRate: 1,
  debug: false,
});

// Shared beforeSend function for filtering events
export const createBeforeSendHandler = (type: 'client' | 'server' | 'edge') => 
  function beforeSend(event: Sentry.Event) {
    const userAgentString = event.request?.headers?.['User-Agent'];
    const errorMessage = event.message || event.exception?.values?.[0]?.value;
    const url = event.request?.url;
    const transactionName = event.transaction;

    // Filter out middleware, Layout Server Component, and Loading Server Component transactions
    if (
      transactionName === 'middleware' ||
      transactionName?.startsWith('Layout Server Component') ||
      transactionName?.startsWith('Loading Server Component')
    ) {
      return null;
    }

    if (type === 'server') {
      const isApiRequest =  event.transaction?.includes('GET') || 
        event.transaction?.includes('POST') ||
        event.transaction?.includes('PUT') ||
        event.transaction?.includes('DELETE') ||
        event.transaction?.includes('PATCH');

      if (!isApiRequest) {
        return null;
      }
    }

    // Filter out HeadlessChrome events
    if (userAgentString?.includes('HeadlessChrome')) {
      return null;
    }

    // Filter out user rejection errors
    if (errorMessage?.includes('User rejected the request')) {
      return null;
    }

    // Filter out permission errors on signout page
    if (url?.includes('/app/signout') && errorMessage?.includes('Missing or insufficient permissions')) {
      return null;
    }

    if (userAgentString) {
      event.tags = {
        ...event.tags,
        supported_browser: isSupportedBrowser(userAgentString),
      };
    }

    return event;
  };